import { AuthApplicationStatus } from '@40seas/entities/auth';
import { EnumColor } from '@40seas/frontend/common/providers';

export const authApplicationStatusColorMapping = {
    [AuthApplicationStatus.ACTIVE]: 'success',
    [AuthApplicationStatus.INACTIVE]: 'error',
    [AuthApplicationStatus.SUSPENDED]: 'warning',
} as { [key in AuthApplicationStatus]: EnumColor };
